import { createStyles } from '@material-ui/core/styles';

export const LoadCreditNotesDialogStyles = createStyles({
    LoadCreditNotesDialogModal: {
        '& .MuiDialogTitle-root': {
            paddingBottom: 10,
            paddingTop: 10
        }
    },
    OrderRecallContainer: {
        maxWidth: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    grid: {
        'maxWidth': '100% !important',
        'height': '100%',
        '& .dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused)': {
            background: '#e6e6e6',
            color: '#333'
        },
        '& .dx-datagrid-rowsview .dx-row-focused.dx-data-row:not(.dx-row-lines) > td': {
            borderBottom: '1px solid #e6e6e6',
            borderTop: '1px solid #e6e6e6',
            borderLeftColor: '#ddd',
            borderRightColor: '#ddd'
        },
        '& .dx-header-row .dx-editor-cell .dx-select-checkbox': {
            display: 'inline-block !important'
        },
        '& .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus': {
            outline: 'unset'
        },
        '& .dx-datagrid-focus-overlay': {
            border: 'none',
        },
        '& .dx-checkbox-icon': {
            color: '#333 !important'
        },
        '& .dx-checkbox-indeterminate .dx-checkbox-icon::before': {
            backgroundColor: '#333 !important'
        }
    },
    OrderRecallToogleContaner: {
        'display': 'flex',
        'flexDirection': 'column',
        'backgroundColor': '#dddddd',
        'bottom': 0,
        'position': 'sticky',
        'zIndex': 2,
        'width': '100%',
        'height': '38px',
        '& label': {
            paddingLeft: '16px',
            background: '#dddddd'
        }
    }
});

export const toggleStyles = createStyles({
    switchBase: {
        '&$checked': {
            '& + $bar': {
                backgroundColor: '#6DD900',
                opacity: 1
            },
        },
    },
    bar: {},
    checked: {},
    formControlLabel: {
        '&$disabled': {
            color: '#555555',
        },
    },
    disabled: {

    },
});
